import Link from 'next/link'
import React from 'react'
import { Typography } from './Typography'

export const LabelWithLink = ({ href, text, mt = false }: { href: string; text: string; mt?: boolean }) => {
  return (
    <>
      <div className={`text-center sm:mb-4 sm:flex sm:flex-wrap ${mt ? 'mt-5' : ''}`}>
        <Link href={href} legacyBehavior={false} className="flex-2" target="_blank" rel="noopener noreferrer">
          <Typography variant="body2" component="span">
            {text}
          </Typography>
        </Link>
      </div>
    </>
  )
}
